<template>
  <div
    class="pagoda-range"
    :class="[
      {
        'pagoda-range--focus': isFocus
      },
      `pagoda-range--${$ELEMENT.size}`
    ]"
  >
    <div class="pagoda-range__range-start">
      <slot name="range-start"></slot>
    </div>
    <span class="date-range-separator">{{rangeSeparator}}</span>
    <div class="pagoda-range__range-end">
      <slot name="range-end"></slot>
    </div>
    <span class="el-input__suffix" @click="$emit('clear')" v-if="clearable">
      <span class="el-input__suffix-inner">
        <i class="el-select__caret el-input__icon el-icon-circle-close pagoda-rang-clear-icon"></i>
      </span>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'Range',
    props: {
      rangeStartFocus: Boolean,
      rangeEndFocus: Boolean,
      rangeSeparator: {
        type: String,
        default: '-'
      },
      clearable: Boolean
    },
    computed: {
      isFocus () {
        return this.rangeStartFocus || this.rangeEndFocus
      }
    }
  }
</script>
